import { HomeGuard } from './home.guard';

export const guards: any[] = [HomeGuard];

export * from './home.guard';

